import React from 'react';
import { MapPin, Phone, Mail, Instagram } from 'lucide-react';
import { ViewState } from '../types';

interface FooterProps {
  onBook: () => void;
  onNav: (view: ViewState) => void;
}

export function Footer({ onBook, onNav }: FooterProps) {
  return (
    <footer className="bg-mier-dark text-stone-50 pt-24 pb-16 px-6 overflow-hidden relative fade-in-up">
      <div className="max-w-7xl mx-auto relative z-10">
        
        {/* Call To Action */}
        <div className="mb-24 text-center border-b border-white/10 pb-20">
          <h2 className="font-serif text-4xl md:text-5xl mb-8 font-light">Elevate Your Beauty Standard</h2>
          <button 
            onClick={onBook}
            className="inline-flex items-center gap-3 bg-stone-50 text-mier px-10 py-5 text-sm tracking-[0.2em] uppercase hover:bg-transparent hover:text-stone-50 border border-stone-50 transition-all duration-300"
          >
            Book Your Appointment Today
          </button>
        </div>

        <div className="grid md:grid-cols-4 gap-16 md:gap-8 mb-24">
          <div className="md:col-span-2 pr-12">
            <h2 className="font-serif text-5xl mb-6">MIER.</h2>
            <p className="text-stone-400 text-sm max-w-sm leading-relaxed">Luxury beauty salon in Abu Dhabi for hair, nails, facials, mesotherapy, lashes, brows, waxing, and bridal beauty near ADNEC and Al Rawdah.</p>
          </div>
          
          <div>
            <h3 className="text-[10px] uppercase tracking-[0.2em] text-mier-light mb-8">Quick Links</h3>
            <div className="flex flex-col gap-3 text-stone-300 text-sm">
              <button onClick={() => onNav('home')} className="hover:text-stone-50 transition-colors w-fit">Home</button>
              <button onClick={() => onNav('about')} className="hover:text-stone-50 transition-colors w-fit">About</button>
              <button onClick={() => onNav('services')} className="hover:text-stone-50 transition-colors w-fit">All Services</button>
              <button onClick={() => onNav('gallery')} className="hover:text-stone-50 transition-colors w-fit">Gallery</button>
              <button onClick={() => onNav('hair-salon')} className="hover:text-stone-50 transition-colors w-fit">Hair Salon</button>
              <button onClick={() => onNav('nail-salon')} className="hover:text-stone-50 transition-colors w-fit">Nail Salon</button>
              <button onClick={() => onNav('skin-treatments')} className="hover:text-stone-50 transition-colors w-fit">Skin Treatments</button>
              <button onClick={() => onNav('bridal')} className="hover:text-stone-50 transition-colors w-fit">Bridal Beauty</button>
              <button onClick={() => onNav('blog')} className="hover:text-stone-50 transition-colors w-fit font-medium text-stone-50">Blog & Insights</button>
              <button onClick={() => onNav('location-al-rawdah')} className="hover:text-stone-50 transition-colors w-fit">Salon Al Rawdah</button>
              <button onClick={() => onNav('location-adnec')} className="hover:text-stone-50 transition-colors w-fit">Salon near ADNEC</button>
              <button onClick={() => onNav('location-aloft')} className="hover:text-stone-50 transition-colors w-fit">Salon at Aloft Hotel</button>
            </div>
          </div>

          <div>
            <h3 className="text-[10px] uppercase tracking-[0.2em] text-mier-light mb-8">Get in Touch</h3>
            <ul className="space-y-4 text-stone-300 text-sm">
              <li><a href="tel:+971543446466" className="hover:text-stone-50 transition-colors flex items-center gap-3"><Phone className="w-4 h-4" /> +971 54 344 6466</a></li>
              <li><a href="mailto:hello@mierlounge.ae" className="hover:text-stone-50 transition-colors flex items-center gap-3"><Mail className="w-4 h-4" /> hello@mierlounge.ae</a></li>
              <li><a href="https://www.instagram.com/mier.lounge/" target="_blank" rel="noopener noreferrer" className="hover:text-stone-50 transition-colors flex items-center gap-3"><Instagram className="w-4 h-4" /> @mier.lounge</a></li>
               <li className="flex items-start gap-3 pt-4 border-t border-white/10 mt-4">
                <MapPin className="w-4 h-4 shrink-0 mt-0.5 text-stone-400" />
                <span className="text-stone-400">Aloft Hotel Ground Floor<br/>Al Rawdah W59 01, Abu Dhabi, UAE<br/>Mon-Sun: 10am — 10pm</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-6 text-xs text-stone-500 uppercase tracking-widest text-[9px]">
          <p>&copy; {new Date().getFullYear()} MIER LOUNGE. All rights reserved.</p>
          <div className="flex items-center gap-8">
            <a href="#" className="hover:text-stone-300 transition-colors">Privacy</a>
            <a href="#" className="hover:text-stone-300 transition-colors">Terms</a>
          </div>
        </div>
      </div>
      
      {/* Massive background text */}
      <div className="absolute bottom-0 left-0 right-0 select-none pointer-events-none text-center translate-y-1/4">
        <span className="font-serif text-[24vw] leading-none text-mier opacity-50 tracking-tighter mix-blend-overlay">MIER.</span>
      </div>
    </footer>
  );
}
